import React from "react";
import { withStory, WithStoryProps } from "@storyofams/storyblok-toolkit";

import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { DynamicSections, Seo } from "../../components";
import {
  enhancedStaticProps,
  withLayout,
  loadCollectionSections,
  loadPopularProducts,
  loadProducts,
} from "../../lib";

import { ProductByHandleQuery } from "../../lib/shopify/sdk";

interface HomePageProps extends WithStoryProps {
  featured_products: ProductByHandleQuery["productByHandle"][];
}

const Home: NextPage<HomePageProps> = ({ story }) => {
  const {
    query: { slug },
  } = useRouter();
  return (
    <>
      <Seo
        story={story}
        canonical={`https://www.naturalheroes.nl/blog/${slug}`}
      />

      <DynamicSections sections={story?.content?.body} />
    </>
  );
};

export default withLayout(withStory(Home));

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    fallback: "blocking",
    paths: [],
  };
};

export const getStaticProps: GetStaticProps<HomePageProps> =
  enhancedStaticProps(async ({ sdk, params, locale, defaultLocale }) => {
    let story = null;
    let notFound = false;

    try {
      story = (
        await sdk.blogItem({
          slug:
            defaultLocale !== locale
              ? `${locale}blog/${params.slug}`
              : `blog/${params.slug}`,
        })
      ).BlogItem;
      story.content.body = story.content.body.reduce(
        (acc, item) =>
          item.component === "dynamic_section"
            ? [...acc, ...item.components]
            : [...acc, item],
        []
      );
    } catch (err) {
      notFound = true;
    }
    await loadCollectionSections(story, locale);

    await loadPopularProducts(story, locale);

    await loadProducts(story, locale);

    // await loadRecipeProducts(story, locale);

    return {
      props: {
        story,
      },
      notFound: notFound || !story,
      revalidate: 600,
    };
  });
